<script setup lang="ts">
import { UiText } from '@shopexperts/shared';

interface Props {
  caption: string;
  heading: string;
  subheading?: string;
  currentStep: number;
  totalSteps: number;
}

defineProps<Props>();
</script>

<template>
  <div class="flex flex-col gap-3">
    <!-- Caption row with step counter and close button -->
    <div class="flex items-center justify-between">
      <UiText as="span" variant="caption" class="text-se-gray-500 uppercase tracking-wider">
        {{ caption }}
      </UiText>
      <div class="flex items-center gap-3">
        <UiText as="span" variant="caption" class="text-se-gray-400">
          {{ currentStep }}/{{ totalSteps }}
        </UiText>
        <slot name="close-button" />
      </div>
    </div>
    
    <!-- Heading -->
    <UiText as="h2" variant="h2" class="text-se-gray-900">
      {{ heading }}
    </UiText>
    
    <!-- Subheading -->
    <UiText v-if="subheading" as="p" variant="p" class="text-se-gray-600">
      {{ subheading }}
    </UiText>
    
    <!-- Optional content after subheading -->
    <slot name="after-subheading" />
  </div>
</template>

